module.exports = __webpack_public_path__ + "static/media/java.6fd01c55.png";